import { StyleSheet, View, ScrollView, SafeAreaView } from "react-native";
import React from "react";

// === Theme ===
import ArTheme from "../../argon-ui/Theme";
// === components ===
import { IconButton } from "../../components_v2/Buttons";
import Text from "../../components_v2/TextFont";

export type Props = {
  children: React.ReactNode;
  title: string;
  // addHandler: () => void;
};
const MenuBarSectionComponents = (props: Props) => {
  let { children, title } = props;
  return (
    <View style={{ flex: 1 }}>
      {/* === header === */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: 10,
          
        }}
      >
        <Text
          style={{
            fontSize: 16,
            color: ArTheme.COLORS.MUTED,
          }}
        >

          {title}
        </Text>
        {/* <IconButton
          style={{
            alignItems: "center",
            marginRight: 10,
            padding:5,
            // backgroundColor: ArTheme.COLORS.BLACK,
          }}
          onPress={() => props.addHandler()}
          icon={{
            code: "\uf067",
            style: {
              fontFamily: "FontAwesomeProLight",
              fontSize: 20,
              color: ArTheme.COLORS.MUTED,
            },
          }}
        /> */}
      </View>
      {/* === children === */}
      {children}
    </View>
  );
};

export default MenuBarSectionComponents;

// const styles = StyleSheet.create({})
